import { ENTITIES } from '@/api/api.constant';
import { SeatSchema } from '@/types/seatSchema';
import { apiBaseUrl } from '@/utils/constants';

export const getSeatSchema = async (id: string): Promise<SeatSchema> => {
    const url = `${apiBaseUrl}${ENTITIES.seatSchema}/${id}?fields=seat_schema.filename_disk`;
    const response = await fetch(url).then((res) => res.json());
    return response?.data?.seat_schema ?? [];
};
